import { call, put, delay } from "redux-saga/effects";
import { courseLevelApi } from "@services/api";
import { getAllCourseLevelActions } from "../slices";

function* getAllCourseLevelWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getAllCourseLevelActions.pending());
    const response = yield call(courseLevelApi.getAllCourseLevel, payload);
    yield put(getAllCourseLevelActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllCourseLevelActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllCourseLevelWorker };
